import React, { useState, useEffect } from "react"
import { Container, Row, Col, Navbar, Nav } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import { Link, useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { setApiToken, setUserInfo } from "../../actions/userActions";
import './Topbar.css'
import { userLoggedIn } from "../../Utils/utils";
import img2 from "../../Login/img/logo.png"
import img3 from "../../Login/img/userimg.png"
import { authMe } from "../../Utils/utils";
import LoadingSpinner from "../LoadingSpinner";
import { Dropdown } from 'react-bootstrap';

const Topbar = (props) => {

  const [authdata, setAuthdata] = useState("")
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const activeTab = location.pathname;





  const handleAuthme = async () => {
    try {
      let response = await authMe()

      setAuthdata(response?.user)
    } catch (error) {
      console.log(error, "error......")
    }
  }

  useEffect(() => {
    handleAuthme()
  }, [])


  const onLogout = () => {
    try {
      setIsLoading(true)
      toast.success("Logout successful");
      localStorage.removeItem('access_token');
      props.setUserInfo("");
      props.setApiToken("");
      // setTimeout(() => navigate(`/`), 3000);
      setTimeout(() => {
        window.location.href = "/";
      }, [2000])
    } catch (error) {
      setIsLoading(false)
    }
  }



  // const getAuth = async () => {
  //   var res = await userLoggedIn();
  //   console.log(res.status ,"response status data here")
  //   if (res.status === 'true') {
  //     props.setUserInfo(res.user);
  //   } else {
  //     navigate(`/`);
  //   }
  // };

  // useEffect(() => {
  //   if (props.userInfo === "") {
  //     getAuth();
  //   }
  // }, []);

  // console.log(activeTab === "/create-class", ".....")

  // console.log(props.userInfo,"userInfo.......");console.log(props.userInfo,"userInfo.......");



  return (
    <>
      <LoadingSpinner isLoading={isLoading} />
      <ToastContainer position="top-center" autoClose={3000} />
      <Navbar expand="lg" className="topbar-container">
        <Container fluid>
          <div className="d-flex align-items-center justify-content-between w-100">


            <div className="d-flex align-items-center logo-container">
              <Link as={Link} to="/dashboard">
                <img src={img2} className="topbar-logo" />
              </Link>
            </div>


            <div className="d-none d-lg-flex flex-grow-1 justify-content-center">
              <Nav className="gap-1">

                <Nav.Link as={Link} to="/upload" className={`menu-button-nav ${activeTab === "/upload" ? "menu-button-nav-active" : ""}`}>Upload</Nav.Link>
                <Nav.Link as={Link} to="/dashboard" className={`menu-button-nav ${activeTab === "/dashboard" ? "menu-button-nav-active" : ""}`}>View</Nav.Link>
                <Nav.Link as={Link} to="/grouped" className={`menu-button-nav ${activeTab === "/grouped" ? "menu-button-nav-active" : ""}`}>Grouped</Nav.Link>
                <Nav.Link as={Link} to="/sou" className={`menu-button-nav ${activeTab === "/sou" ? "menu-button-nav-active" : ""}`}>SOU</Nav.Link>
                <Nav.Link as={Link} to="/create-class" className={`menu-button-nav ${activeTab === "/create-class" ? "menu-button-nav-active" : ""}`}>Create Class</Nav.Link>
                <Nav.Link as={Link} to="/class-created" className={`menu-button-nav ${activeTab === "/class-created" ? "menu-button-nav-active" : ""}`}>Classes</Nav.Link>
                <Nav.Link as={Link} to="/view-class" className={`menu-button-nav ${activeTab === "/view-class" ? "menu-button-nav-active" : ""}`}>View Class</Nav.Link>

                <Nav.Link as={Link} to="/training" className={`menu-button-nav ${activeTab === "/training" ? "menu-button-nav-active" : ""}`}>Training</Nav.Link>
                <Nav.Link as={Link} to="/holiday" className={`menu-button-nav ${activeTab === "/holiday" ? "menu-button-nav-active" : ""}`}>Holiday</Nav.Link>
                <Nav.Link as={Link} to="/archived" className={`menu-button-nav ${activeTab === "/archived" ? "menu-button-nav-active" : ""}`}>Archived</Nav.Link>
              </Nav>
            </div>


            {authdata && (
              <div className="d-flex align-items-center flex-shrink-0">
                <Dropdown className="userData">
                  <Dropdown.Toggle className="p-0 shadow-none d-flex align-items-center gap-2 dropdown-user" id="dropdown-user">
                    <img src={img3} className="img-fluid" alt="User" />
                  </Dropdown.Toggle>

                  <Dropdown.Menu align="end">
                    <Dropdown.Item>
                      <span className="no-underline">{authdata}</span>
                    </Dropdown.Item>
                    <Dropdown.Item className="dropdown-text" onClick={onLogout}>
                      <span className="logout">Logout</span>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            )}
          </div>
        </Container>
      </Navbar>



    </>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setUserInfo: (apiToken) => dispatch(setUserInfo(apiToken)),
  setApiToken: (apiToken) => dispatch(setApiToken(apiToken)),
});

const mapStateToProps = (state) => ({
  userdata: state.userInfo,
  apiToken: state.apiToken,
});

export default connect(mapStateToProps, mapDispatchToProps)(Topbar);
